import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-close",
  "use": "svg_i-close-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"svg_i-close\"><path d=\"m10.9 9.485 7.778 7.778a1 1 0 0 1-1.415 1.415l-7.778-7.779-7.778 7.779a1 1 0 0 1-1.414-1.415L8.07 9.485.293 1.707A1 1 0 0 1 1.707.293L9.485 8.07 17.263.293a1 1 0 0 1 1.415 1.414l-7.779 7.778z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol